import { Clock3, Crown } from 'lucide-react';

import { useI18n } from '../../i18n/useI18n';
import { usePlanSummary } from './billing.api';

export function PlanStatusBanner({ onUpgrade }: { readonly onUpgrade: () => void }) {
  const { t } = useI18n();
  const summary = usePlanSummary();
  if (summary.data?.plan !== 'free') return null;

  const trial = summary.data.trial;
  return (
    <aside className={trial.active ? 'trial-banner' : 'trial-banner is-expired'} role="status">
      <div className="trial-banner-icon">
        {trial.active ? <Clock3 aria-hidden="true" /> : <Crown aria-hidden="true" />}
      </div>
      <div>
        <strong>
          {trial.active
            ? t(trial.daysLeft === 1 ? 'billing.trialDay' : 'billing.trialDays', {
                days: trial.daysLeft,
              })
            : t('billing.trialExpired')}
        </strong>
        <p>{trial.active ? t('billing.trialDescription') : t('billing.trialExpiredDescription')}</p>
      </div>
      <button className="button button-ghost" type="button" onClick={onUpgrade}>
        {t('billing.viewPlans')}
      </button>
    </aside>
  );
}
